export default __webpack_public_path__ + "static/media/win.47b53239.svg";